module.exports = "pegasus_template/assets/blocks/column-16-theme2.png";